import { HttpParams, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class ProdutoCampoPersonalizadoService {

  constructor(
    private http: HttpClient
  ) { }

  consultarProdutoCampoPersonalizadoComPaginacao(descri: string, paginaAtual, qtdRegistros, campoOrdenacao, orientacaoOrdenacao, tipoAplicacao) {

    let parametros = new HttpParams()
      .set('pag', paginaAtual)
      .set('qt', qtdRegistros)
      .set('ordem', campoOrdenacao)
      .set('asc_desc', orientacaoOrdenacao)
      .set('tipoAplicacao', tipoAplicacao);

    if (descri.trim() !== '') {
      parametros = parametros.set('descri', descri);
    }

    return this.http.get<any>(globals.apiUrl + '/api/ProdutoCampoPersonalizado/ListaPag',
      {
        params: parametros
      });
  }

  consultarTodosProdutoCampoPersonalizado() {
    return this.http.get<any>(globals.apiUrl + '/api/ProdutoCampoPersonalizado/Lista');
  }

  consultarPorIdProdutoCampoPersonalizado(id) {
    return this.http.get<any>(globals.apiUrl + '/api/ProdutoCampoPersonalizado/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  consultarPorMenuIdCampoPersonalizado(id) {
    return this.http.get<any>(globals.apiUrl + '/api/ProdutoCampoPersonalizado/ListarPorMenu',
      { params: new HttpParams().set('id', id) });
  }

  salvar(campoPersonalizado) {
    return this.http.post(globals.apiUrl + '/api/ProdutoCampoPersonalizado/Salvar', campoPersonalizado);
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/ProdutoCampoPersonalizado/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  verificaSePodeExcluirItem(id) {
    return this.http.get<any>(globals.apiUrl + '/api/ProdutoCampoPersonalizado/PodeExcluirItem',
      { params: new HttpParams().set('idItem', id) });
  }
}
